import Icon from '../components/Icon.vue'

Icon.register({
  road: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M573.2 402.7c9.3 21.2-5.5 45.3-27.7 45.3h-196.8l-10.3-97.7c-0.9-8.1-7.7-14.3-15.9-14.3h-68.8c-8.2 0-15 6.2-15.9 14.3l-10.3 97.7h-196.8c-22.2 0-37-24.1-27.7-45.3l139.8-320c5-11.4 15.8-18.7 27.7-18.7h97.6l-2.5 23.2c-0.5 4.7 3.2 8.8 8 8.8h29.2c4.8 0 8.5-4.1 8-8.8l-2.5-23.2h97.6c11.9 0 22.8 7.3 27.7 18.7zM260.4 135.2l-4.6 43.6c-0.8 7.1 4.8 13.3 11.9 13.3h40.5c7.1 0 12.7-6.2 11.9-13.3l-4.6-43.6c-0.4-4.1-3.9-7.2-8-7.2h-39.3 0c-4 0-7.5 3.2-8 7.2zM315.6 304c9.5 0 16.9-8.2 15.9-17.7l-5.1-48c-0.9-8.1-7.7-14.3-15.9-14.3h-45.2c-8.2 0-15 6.2-15.9 14.3l-5.1 48c-1 9.4 6.4 17.7 15.9 17.7h55.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/road.js
// module id = 1843
// module chunks = 0